import React from 'react';
import { Grid, List } from 'semantic-ui-react';
import { themes } from '../../theme/context';
import { HomeIcon } from '../Icons/HomeIcon';
import * as ProjectIcons from '../Icons/ProjectIcons';
import { SubMenuLink, CustomHeader, HomeLink, PDFIcon } from './style';
export var ActLinksMenu = function (_a) {
    var _b, _c;
    var inverted = _a.inverted, allMenuLinks = _a.allMenuLinks, actMode = _a.actMode, drupalHost = _a.drupalHost;
    if (!allMenuLinks)
        return null;
    var renderColumns = function () {
        var _a;
        var links = (_a = allMenuLinks[actMode]) !== null && _a !== void 0 ? _a : allMenuLinks['default'];
        var footerMenuTitles = (links === null || links === void 0 ? void 0 : links.parentTitles) || [];
        var footerMenuChilds = (links === null || links === void 0 ? void 0 : links.childTitles) || [];
        //высоты столбцов меню 
        var heights = [0, 0, 0];
        return Object.keys(footerMenuTitles).reduce(function (items, id) {
            //пункт меню итоги в последнем столбце
            var minIndex = footerMenuTitles[id].parentTitle === 'Итоги' ? 2 : heights.findIndex(function (i) { return i === Math.min.apply(Math, heights); });
            var height = 0;
            var list = Object.keys(footerMenuChilds).reduce(function (items, childId) {
                if (footerMenuChilds[childId].parentId == id) {
                    var link = footerMenuChilds[childId].childLinkPath, isPdf = !!~link.search(/\.pdf/);
                    height += (34.6 + Math.floor(footerMenuChilds[childId].childTitle.length / 32) * 20.4);
                    items.push(React.createElement(SubMenuLink, { key: childId, href: link, target: isPdf ? '_blank' : '_self' },
                        isPdf && React.createElement(PDFIcon, { name: "file pdf outline" }),
                        " ",
                        footerMenuChilds[childId].childTitle));
                }
                return items;
            }, []);
            items[minIndex] = (React.createElement(Grid.Column, { key: id },
                items[minIndex] && React.Children.map(items[minIndex].props.children, function (c) { return c; }),
                React.createElement(CustomHeader, { inverted: inverted, as: 'h3' }, footerMenuTitles[id].parentTitle),
                React.createElement(List, { inverted: inverted }, list)));
            heights[minIndex] += height;
            return items;
        }, []);
    };
    var ProjectIcon = ProjectIcons[actMode];
    var href = '//' + (((_b = themes[actMode]) === null || _b === void 0 ? void 0 : _b.href) ? ((_c = themes[actMode]) === null || _c === void 0 ? void 0 : _c.href) + '.' : '') + drupalHost;
    if (actMode === 'fepo_pro')
        href += '/fepo_pro';
    if (actMode === 'test_constructor')
        href += '/test_constructor';
    return React.createElement(React.Fragment, null,
        actMode !== 'olymp_en' &&
            React.createElement(HomeLink, null,
                React.createElement(List, { inverted: inverted },
                    React.createElement(SubMenuLink, { href: href },
                        actMode === 'default' ?
                            React.createElement(HomeIcon, null)
                            :
                                ProjectIcon ? React.createElement(ProjectIcon, null) : null,
                        React.createElement("span", null, actMode === 'default' ? 'i-exam.ru' : 'О сервисе')),
                    React.createElement(SubMenuLink, { href: "//".concat(drupalHost, "/sites/default/files/instrukcia_%D0%95%D0%9B%D0%9A.pdf"), target: "_blank" },
                        React.createElement("span", null,
                            React.createElement(PDFIcon, { name: "file pdf outline" }),
                            " ",
                            actMode === 'default' ? 'Как получить доступ к сервисам' : 'Как получить доступ к сервису')),
                    React.createElement(SubMenuLink, { href: "//".concat(drupalHost, "/sites/default/files/sites/Metodicheskiye_rekomendatsii.pdf"), target: "_blank" },
                        React.createElement("span", null,
                            React.createElement(PDFIcon, { name: "file pdf outline" }),
                            "\u041C\u0435\u0442\u043E\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0438")))),
        React.createElement(Grid, { stackable: true, columns: 3 },
            React.createElement(Grid.Row, null, renderColumns())));
};
//# sourceMappingURL=ActLinksMenu.js.map